// extracted by css-extract-rspack-plugin
export default {"paginatorWithResult":"PaginatorWithResult__paginatorWithResult--EZd9Z","resultRight":"PaginatorWithResult__resultRight--Qvit4"};